export default function () {
  const widgetName = 'featureCardsIcons';
  const widgetOpts = featureCardsIconsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {


        let number = 1;
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          $(this).find('.card-content').remove();

          $(this).find('.card-widget-image').each(function () {
            let attr = $(this).attr('data-src');
            $('#featureCards').find(`.icon-${number}`).attr('src', attr)
            number++;
          });

          $(this).css('opacity', '0');
          setTimeout(() => {
            $(this).remove();
          }, 1000);
        })
      }
      customWidget()
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });
}